module.exports = __webpack_public_path__ + "img/pop2.be4fe908.png";